import { Route, Routes } from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import HomePage from './pages/HomePage';
import Footer from './components/Footer';
import AboutPage from './pages/AboutPage';
import ServicePage from './pages/ServicePage';
import ContactUs from './pages/ContactUs';
import RegisterPage from './pages/RegisterPage';
import StarLawyersPage from './pages/StarLawyersPage';
import LawyerServicesPage from './pages/LawyerServicesPage';
import NewsPage from './pages/NewsPage';

function App() {
  return (
    <div className="app">
      <NavBar />
      <Routes>
        <Route index element={<HomePage />} />
        <Route path='/' element={<HomePage />} />
        <Route path='/home' element={<HomePage />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/services' element={<ServicePage />} />
        <Route path='/contact' element={<ContactUs />} />
        <Route path='/register' element={<RegisterPage />} />
        <Route path='/lawyer-services' element={<LawyerServicesPage />} />
        <Route path='/star-lawyers' element={<StarLawyersPage />} />
        <Route path='/news' element={<NewsPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;